export default "__VITE_ASSET__35b4a8d5__"